export default __webpack_public_path__ + "static/media/Dahlia4Carton-SET.bbfd5fea.jpg";